import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { host } from "../config/Config";
import "./educations/style.css";
import Logo from "../resources/logo.png";
import bgImage from "../resources/bground.jpeg";

export const EducationConfirmation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoggingIn, setIsLoggingIn] = useState(false);
    const [navigating, setNavigating] = useState(false);

    const { phone, password, isAlreadyLoggedIn } = location.state || {};

    useEffect(() => {
        // Redirect if no phone provided
        if (!phone) {
            navigate("/educations");
        }
    }, [phone, navigate]);

    const handleAccept = async () => {
        // If user is already logged in, skip login and just redirect
        if (isAlreadyLoggedIn) {
            setNavigating(true);
            setTimeout(() => {
                navigate("/my-educations");
            }, 2500);
            return;
        }

        setIsLoggingIn(true);
        try {
            // Auto-login the user
            const loginResponse = await fetch(`${host}/api/v1/auth/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    username: phone,
                    password: password,
                }),
            });

            if (loginResponse.ok) {
                const loginData = await loginResponse.json();
                // Store JWT token for education users (NOT jwt-vlada, that's admin only)
                if (loginData.token) {
                    localStorage.setItem("zajednica-token", loginData.token);
                    localStorage.setItem("zajednica-phone", phone);
                    if (loginData.name) {
                        localStorage.setItem("zajednica-name", loginData.name);
                    }
                    localStorage.setItem(
                        "zajednica-user-type",
                        loginData.isEducationUser === true
                            ? "education"
                            : "regular"
                    );
                }
                // Redirect to my educations page after 2.5 second delay
                setNavigating(true);
                setTimeout(() => {
                    navigate("/my-educations");
                }, 2500);
            } else {
                alert(
                    "Došlo je do greške pri prijavljivanju. Molimo pokušajte ponovo."
                );
                navigate("/login");
            }
        } catch (error) {
            console.error("Auto-login failed:", error);
            alert(
                "Došlo je do greške pri prijavljivanju. Molimo pokušajte ponovo."
            );
            navigate("/login");
        } finally {
            if (!navigating) {
                setIsLoggingIn(false);
            }
        }
    };

    return (
        <div className='page'>
            <div
                style={{
                    minHeight: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "40px 20px",
                    backgroundImage: `url(${bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundAttachment: "fixed",
                }}
            >
                <div
                    style={{
                        maxWidth: "700px",
                        width: "100%",
                        backgroundColor: "rgba(30, 30, 30, 0.85)",
                        borderRadius: "16px",
                        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.5)",
                        padding: "50px 40px",
                        textAlign: "center",
                        border: "1px solid #333",
                        backdropFilter: "blur(10px)",
                    }}
                >
                    <h1
                        style={{
                            fontSize: "32px",
                            color: "#be9455",
                            marginBottom: "30px",
                            fontWeight: "bold",
                        }}
                    >
                        Uspešna Prijava!
                    </h1>

                    <div
                        style={{
                            fontSize: "17px",
                            color: "#ccc",
                            lineHeight: "1.8",
                            marginBottom: "35px",
                            textAlign: "left",
                        }}
                    >
                        <p style={{ marginBottom: "15px" }}>
                            Hvala što ste se prijavili za edukaciju u{" "}
                            <strong style={{ color: "#be9455" }}>
                                Barber Zajednica
                            </strong>
                            .
                        </p>

                        <div
                            style={{
                                backgroundColor: "#252525",
                                padding: "20px",
                                borderRadius: "8px",
                                marginBottom: "20px",
                                border: "1px solid #3a3a3a",
                            }}
                        >
                            <h3
                                style={{
                                    color: "#be9455",
                                    marginBottom: "15px",
                                    fontSize: "18px",
                                }}
                            >
                                💳 Plaćanje
                            </h3>
                            <p style={{ marginBottom: "10px" }}>
                                Možete izvršiti uplatu na sledeći način:
                            </p>
                            <ul
                                style={{
                                    textAlign: "left",
                                    paddingLeft: "20px",
                                    color: "#ddd",
                                }}
                            >
                                <li style={{ marginBottom: "8px" }}>
                                    <strong>Bankovni račun:</strong> Uplatu je
                                    neophodno izvršiti pre početka edukacije.
                                    Uplatnica sa podacima će vam biti poslata na
                                    email adresu.
                                </li>
                            </ul>
                        </div>

                        <div
                            style={{
                                backgroundColor: "#252525",
                                padding: "20px",
                                borderRadius: "8px",
                                marginBottom: "20px",
                                border: "1px solid #3a3a3a",
                            }}
                        >
                            <h3
                                style={{
                                    color: "#be9455",
                                    marginBottom: "15px",
                                    fontSize: "18px",
                                }}
                            >
                                📋 Status prijave
                            </h3>
                            <p style={{ marginBottom: "10px" }}>
                                Vaša prijava je u statusu{" "}
                                <strong style={{ color: "#8b7028" }}>
                                    NA ČEKANJU
                                </strong>{" "}
                                dok je ne verifikuje Barber Zajednica.
                            </p>
                            <p>
                                Nakon što se uplata obradi, vaš status prelazi u
                                ODOBREN i to ćete moći da proverite na vašem
                                profilu. Ukoliko imate dodatnih pitanja,
                                slobodno nas kontaktirajte putem telefona.
                            </p>
                        </div>

                        <div
                            style={{
                                marginTop: "30px",
                                marginBottom: "20px",
                                textAlign: "center",
                            }}
                        >
                            <img
                                src={Logo}
                                alt='Barber Zajednica Logo'
                                style={{ width: "120px", opacity: "0.8" }}
                            />
                        </div>

                        <p
                            style={{
                                textAlign: "center",
                                color: "#aaa",
                                fontSize: "15px",
                            }}
                        >
                            Kliknite na dugme ispod da pređete na stranicu{" "}
                            <strong>Moje Edukacije</strong>.
                        </p>
                    </div>

                    <button
                        onClick={handleAccept}
                        disabled={isLoggingIn || navigating}
                        style={{
                            backgroundColor: "#be9455",
                            color: "white",
                            border: "none",
                            padding: "16px 50px",
                            fontSize: "18px",
                            fontWeight: "bold",
                            borderRadius: "8px",
                            cursor:
                                isLoggingIn || navigating
                                    ? "not-allowed"
                                    : "pointer",
                            transition: "all 0.3s",
                            opacity: isLoggingIn || navigating ? 0.7 : 1,
                            whiteSpace: "pre-line",
                            boxShadow: "0 4px 12px rgba(190, 148, 85, 0.3)",
                        }}
                        onMouseEnter={(e) => {
                            if (!isLoggingIn && !navigating) {
                                e.target.style.backgroundColor = "#a07d3f";
                                e.target.style.transform = "translateY(-2px)";
                                e.target.style.boxShadow =
                                    "0 6px 16px rgba(190, 148, 85, 0.4)";
                            }
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "#be9455";
                            e.target.style.transform = "translateY(0)";
                            e.target.style.boxShadow =
                                "0 4px 12px rgba(190, 148, 85, 0.3)";
                        }}
                    >
                        {navigating
                            ? "Obrađujem..."
                            : isLoggingIn
                            ? "Prijavljivanje..."
                            : "Prihvatam\nNastavi dalje"}
                    </button>
                </div>
            </div>
        </div>
    );
};
